export const randomString = (length) => {
  var result = "";
  var characters =
    "abcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};
// export function capitalize(str) {
//   return str.charAt(0).toUpperCase() + str.slice(1);
// }

export function capitalize(str) {
  var splitStr = str?.toLowerCase()?.split(' ');
  for (var i = 0; i < splitStr?.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you
      // Assign it back to the array
      splitStr[i] = splitStr?.[i]?.charAt(0)?.toUpperCase() + splitStr?.[i]?.substring(1);     
  }
  // Directly return the joined string
  return splitStr?.join(' '); 
}

export function nFormatter(num, digits) {
  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "k +" },
    { value: 1e6, symbol: "M +" },
    { value: 1e9, symbol: "G +" },
    { value: 1e12, symbol: "T +" },
    { value: 1e15, symbol: "P +" },
    { value: 1e18, symbol: "E +" }
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = lookup.slice().reverse().find(function(item) {
    return num >= item.value;
  });
  return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
}